/* eslint-disable camelcase */
import axios from "axios";
import { wmSign } from "../../apiFunc/encrypt";
import { GetTimeStamp } from "../../apiFunc/getDate";
import { getCookie } from "../../apiFunc/getCookie";

const oauthURL = `${process.env.REACT_APP_OAUTH_URL}`;
const header = {
  "Content-Type": "application/json",
  "Accept-Language": "en",
  "app-id": process.env.REACT_APP_ID,
  "device-uuid": process.env.REACT_APP_DEVICE_UUID,
};

async function GetInfo() {
  const body = {
    request_parameter: {
      random_key: getCookie(),
    },
    timestamp: GetTimeStamp(),
  };
  const sign = wmSign(body);
  const data = {
    sign: sign,
  };
  const response = await axios.post(`${oauthURL}/oauth/info`, data, {
    headers: header,
  });
  return response.data;
}

async function Approve(state, clientId) {
  const body = {
    member_access_token:
      sessionStorage.getItem("member_access_token") ||
      localStorage.getItem("member_access_token"),
    request_parameter: {
      random_key: getCookie(),
      authToken: sessionStorage.getItem("auth_token"),
      client_id: clientId,
      state: state,
    },
    timestamp: GetTimeStamp(),
  };
  const sign = wmSign(body);
  const data = {
    sign: sign,
  };
  const response = await axios.post(`${oauthURL}/oauth/authorize`, data, {
    headers: header,
  });
  return response.data;
}

async function Deny(state, clientId) {
  const body = {
    member_access_token:
      sessionStorage.getItem("member_access_token") ||
      localStorage.getItem("member_access_token"),
    request_parameter: {
      random_key: getCookie(),
      authToken: sessionStorage.getItem("auth_token"),
      client_id: clientId,
      state: state,
    },
    timestamp: GetTimeStamp(),
  };
  const sign = wmSign(body);
  const data = {
    sign: sign,
  };
  const requestOption = {
    headers: header,
    data: data,
  };
  const response = await axios.delete(
    `${oauthURL}/oauth/authorize`,
    requestOption
  );
  return response.data;
}

export { GetInfo, Approve, Deny };
